export default `
  mutation ClubRegistrationSalesforce($input: CustomerCreateInput!) {
    clubRegistrationSalesforce(input: $input) {
     status
     message
    }
  }
`;
